import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setIsError } from 'redux/ApiResponseStatusGlobalDisplay/slice';
import { getUserLanguageCode } from 'redux/User/selectors';
import { storePermissions } from 'redux/User/slice';
import { PLATFORM_LANGUAGE } from 'services/api/constants';
import { fetchUserPermissions } from 'services/api/permissions/client';
import { updateUserLanguage } from 'services/api/userMetadata/client';
import { logger } from 'services/logs/logger';

export const LanguageSwitchToggle = () => {
  const dispatch = useDispatch();
  const platformLanguage = useSelector(getUserLanguageCode) || PLATFORM_LANGUAGE;
  const [language, setLanguage] = useState(platformLanguage);

  const toggleLanguage = async () => {
    const newLanguage = language === 'en' ? 'fr' : 'en';
    setLanguage(newLanguage);

    try {
      const response = await updateUserLanguage(newLanguage);
      if (!response.status) {
        dispatch(setIsError(true));
      }
      const permissions = await fetchUserPermissions();
      dispatch(storePermissions(permissions));
    } catch (error) {
      dispatch(setIsError(true));
      logger.logError(`Failed to update language:`, error);
    }
  };

  return (
    <FormControlLabel
      control={
        <Switch
          name="languageSwitch"
          color={language === 'en' ? 'default' : 'primary'}
          checked={language === 'fr'}
          onChange={toggleLanguage}
        />
      }
      label={language === 'en' ? 'English' : 'French'}
      labelPlacement="start"
    />
  );
};
